import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(
    () => ({
      ...data,
      appointment_booking: props.appointmentBooking,
      patient_id: props.patientId,
      location_id: props.locationId,
    }),
    [data, props.appointmentBooking, props.patientId, props.locationId]
  )
}
